<template>
    <div>


        <div class="section-title mb-5" v-if="dailyPicksOffers.length > 0">
            Daily Picks
        </div>




        <div class="offers-list__container" v-if="!loadingHomeFeedOffers">
            <div v-for="(tile, index) in dailyPicksOffers" :key="index">


                <RectangleOfferTile :offer="tile" @click="offerTileClicked(tile)"></RectangleOfferTile>


            </div>
        </div>


        <div v-if="loadingHomeFeedOffers" class="offers-list__container">
            <v-skeleton-loader :elevation="4" type="list-item-avatar-three-line" v-for="n in 20" :key="n"
                color="var(--v-skeleton-loader-color)"></v-skeleton-loader>
        </div>


        <OfferDetailsDialog :offer="selectedOffer" @report-offer="openReportOfferDialog" />

        <ReportOfferDialog />




    </div>
</template>



<script setup>

import { computed, ref, provide } from 'vue';
import { OfferStore } from '@/store/offerStore';

import RectangleOfferTile from '@/components/Tiles/Offer/Rectangle-Offer-Tile.vue';
import OfferDetailsDialog from '../../Offer/StartOfferDialogComponents/Offer-Details-Dialog.vue';
import ReportOfferDialog from '../../Offer/StartOfferDialogComponents/Report-Offer-Dialog.vue';

const offerStore = OfferStore();
const selectedOffer = computed(() => offerStore.selectedOffer);
const loadingHomeFeedOffers = computed(() => offerStore.loadingHomeFeedOffers);
const dailyPicksOffers = computed(() => offerStore.dailyPicksOffers);

const offerDetailsDialogOpen = ref(false);
provide('offerDetailsDialogOpen', offerDetailsDialogOpen);

const reportOfferDialogOpen = ref(false);
provide('reportOfferDialogOpen', reportOfferDialogOpen);

const offerTileClicked = (offer) => {
    offerStore.selectOffer(offer);
    offerDetailsDialogOpen.value = true;
}

const openReportOfferDialog = () => {
    offerDetailsDialogOpen.value = false;
    reportOfferDialogOpen.value = true;
}

</script>